import {createFileRoute, redirect} from '@tanstack/react-router'

/**
 * `/pricing-v2` was a second, unlinked pricing page rendering landing/PricingPage.tsx.
 *
 * It was never linked from the app or listed in the sitemap, but it was LIVE and crawlable —
 * scorepal.co/pricing-v2/ returned 200, robots.txt allows everything, and it emitted pricing
 * JSON-LD. It also carried a third, stale price list ($69/mo, $15/mo, $4.99, $1.99) matching
 * neither the current plans nor the ones before them.
 *
 * One page owns the prices now: /pricing. This redirects rather than 404s so any bookmark, inbound
 * link or indexed copy lands on the real thing instead of dying — a 404 would throw away whatever
 * the URL has accumulated, and it costs nothing to keep it pointing somewhere true.
 *
 * The old component is deleted; there is nothing left here to drift.
 */
export const Route = createFileRoute('/pricing-v2')({
    beforeLoad: () => {
        throw redirect({to: '/pricing/', statusCode: 301});
    },
})
